'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'explosion';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e4e9';
var svgPathData = 'M55.6 355.4l71.1 10.2L144 368l-4.6-16.8L103.7 220.3 96 192l21.9 19.5 108.3 96.3L240 320l3.8-18.1L280 128l16 0 35.3 162.2L336 312l12.3-18.5L513.2 46.2 544 0 527.8 53.1l-90.7 298L432 368l17.5-2.5 70.9-10.1L544 352l-15.3 18.3-78 93.7-20.8 0 75.2-90.3-70.8 10.1-24.9 3.6 7.3-24.1L497.1 99.2 349.3 320.9l-20.9 31.4-8-36.9L288.2 167.3l-32.5 156L250 350.3 229.4 332 125.6 239.7l33.8 124.1 6.4 23.5-24.1-3.4L70.9 373.7 146.2 464l-20.8 0-78-93.7L32 352l23.6 3.4zM296 8l0 80 0 8-16 0 0-8 0-80 0-8 16 0 0 8zM8 496l184.3 0c4.1-49.3 45.3-88 95.7-88s91.6 38.7 95.7 88L568 496l8 0 0 16-8 0-191.9 0-.1 0-.1 0-175.8 0c0 0-.1 0-.1 0s-.1 0-.1 0L8 512l-8 0 0-16 8 0zm200.4 0l159.2 0c-4-40.4-38.1-72-79.6-72s-75.6 31.6-79.6 72z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faExplosion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;